import { useCallback } from 'react';
import { Icon } from 'src/common/components/icon';
import { useOpenModal, useCloseModal } from 'src/common/components/next-modal';
import { ActivityIds } from 'src/hooks/activities/activity-ids';
import { getActivity } from 'src/hooks/activities/use-activity';
import { useFetchActivities } from 'src/hooks/activities/use-fetch-activities';
import { Modals } from 'src/modals';
import { TocType, TocTypeName } from 'src/views/main/aside/toc/types';
import { useOpenNewPageGuide } from './create-new-page-guide';

export const useCreatePageTip = () => {
  const openModal = useOpenModal();
  const closeModal = useCloseModal();
  const openNewPageGuide = useOpenNewPageGuide();
  const fetchActivities = useFetchActivities();

  return useCallback(async () => {
    await fetchActivities();

    const activity = getActivity(ActivityIds.CREATE_NEW_PAGE);
    if (!(activity && activity.status !== 'completed')) {
      return;
    }

    const nodeList = document.querySelectorAll('.add-page');
    const addPageNode = Array.from(nodeList).find(
      (node) =>
        node.classList.contains(TocTypeName[TocType.PRIVATE]) ||
        node.classList.contains(TocTypeName[TocType.SPACE])
    );
    if (!addPageNode) return;

    const type = addPageNode.classList.contains(TocTypeName[TocType.PRIVATE])
      ? TocType.PRIVATE
      : TocType.SPACE;
    const rect = addPageNode.getBoundingClientRect();

    openModal.modal({
      modalId: Modals.CREATE_PAGE_TIP,
      noAnimation: true,
      disableDefaultStyle: true,
      content: () => {
        return (
          <div
            className="bg-black/5 w-full h-full fixed inset-0"
            onClick={() => {
              closeModal(Modals.CREATE_PAGE_TIP);
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="flex flex-col items-center absolute -translate-x-1/2"
              style={{ left: Math.max(rect.left, 100), top: rect.top }}
            >
              <button
                onClick={() => {
                  openNewPageGuide(type);
                  closeModal(Modals.CREATE_PAGE_TIP);
                }}
                className="rounded-md cursor-pointer animate-hover flex justify-center items-center w-6 h-6 bg-white1 animate-bounce"
              >
                <Icon name="IcAdd" size="small" className="block" />
              </button>
              <div hidden={__BUILD_IN__} className="next-modal text-t2 p-2.5 relative mt-2">
                首次创建页面得 ⭐️+5 <br />
                可累积抵现兑会员
                <div id="triangle-up-center" />
              </div>
            </div>
          </div>
        );
      },
    });
    return true;
  }, [closeModal, fetchActivities, openModal, openNewPageGuide]);
};
